var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"text-center text-3xl py-6"},[_vm._v(_vm._s(_vm._("You're too far to grab this call.")))]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._( "Get Closer" )))])])
}
var staticRenderFns = []

export { render, staticRenderFns }